/**
 * @author        xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright     Copyright (c) 2021, Zumper
 */

import { Theme, css } from '@emotion/react'
import { focusRing } from '@zcode-ui/themes'

export const button = ({ colors, spacing, typography }: Theme) => css`
  font-weight: ${typography.fontWeightMedium};
  font-size: ${typography.fontSize16};
  font-family: ${typography.bodyFontFamily};
  line-height: 24px;
  letter-spacing: -0.2px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;

  border: 0;
  border-radius: 6px;
  cursor: pointer;

  transition: all 100ms ease-in;

  user-select: none;

  label: button;

  :disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:focus-visible {
    ${focusRing({ colors, spacing, typography })}
  }
`

export const clearButton = ({ colors }: Theme) => css`
  padding-right: 0;
  padding-left: 0;

  color: ${colors.textLightest};

  background-color: transparent;
  border: 0;

  label: clearbutton;

  :hover:not(:disabled) {
    color: ${colors.textLight};
    background-color: transparent;
  }

  :active:not(:disabled) {
    color: ${colors.text};
  }
`
